// extracted by mini-css-extract-plugin
module.exports = {"blurb":"blurb-module--blurb--1j7XU","more":"blurb-module--more--2jFQN"};